import { render, staticRenderFns } from "./addClinic.vue?vue&type=template&id=46c9d212"
import script from "./addClinic.vue?vue&type=script&lang=js"
export * from "./addClinic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports